import { Injectable } from '@angular/core';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {RoutingInterfaceFilterService} from '../../../../../network/utils/filters/routing-interface/routing-interface-filter.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingInterfaceApiService {

  constructor(private http: HttpClient) {}

  readonly routingInterfaceUrl: string = 'topology/routingInterface';

  public getRoutingInterfacesForMap(params: any = {}): Promise<any> {
    return this.http.get(this.routingInterfaceUrl)
      .pipe(
        map((routingInterfaces) => {
          return this.filterRIs(routingInterfaces, params);
        })
      ).toPromise();
  }

  public getRoutingInterfaces(params: any = {}): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.routingInterfaceUrl, {filter: params});
    return this.http.get(url).toPromise();
  }

  public getRoutingInterface(id): Promise<any> {
    return this.http.get(`${this.routingInterfaceUrl}/${id}`).toPromise();
  }

  private filterRIs(routingInterfaces, params): any {
    return (params && params.filter) ?
      RoutingInterfaceFilterService.filter(routingInterfaces, params.filter) : routingInterfaces;
  }
}
